import * as React from "react";
import { Stack, Typography } from "@mui/material";
import { text } from "@/theme/colors";
import logo from "@/assets/images/logo_white.svg";

export const IconLogo = (): React.JSX.Element => (
  <Stack direction="row" alignItems="center" justifyContent="space-between" gap={1}>
    <img width={211} src={logo} alt="logo" />
    <svg width="1" height="28" viewBox="0 0 1 28" fill="none" xmlns="http://www.w3.org/2000/svg">
      <line x1="0.5" y1="28" x2="0.5" stroke="#E6E7E8" />
    </svg>
    <Typography variant="head20Bold" color={text.white} sx={{ marginTop: "4px" }}>
      システム管理
    </Typography>
  </Stack>
);
